import appNav from './appNav.vue'

export default appNav
